export default __webpack_public_path__ + "static/media/music-logo.58b2889e.gif";